export const clientActiveStatus = {
  ACTIVE: 'active',
  INACTIVE: 'inactive',
};

export const clientIntakeStatus = {
  ON: 'on',
  OFF: 'off',
};
